<template>
    <v-ons-page>
        <ons-toolbar class="main-toolbar">
            <div class="left">
            </div>
            <div class="center brand-toobar">
                <img src="/logo_v2.png" class="logo">
            </div>
            <div class="right">
                <ons-toolbar-button v-on:click="$router.go(-1)">
                    <i class="fal fa-times"/>
                </ons-toolbar-button>
            </div>
        </ons-toolbar>

        <div class="content full main-background">
            <div class="eula-container">
                <div class="eula card">
                    <eula-text/>
                </div>
            </div>
        </div>

    </v-ons-page>
</template>

<script>
import EulaTextComponent from './fragments/eula_text'

export default {
    name: 'EULA',
    components: {
        'eula-text': EulaTextComponent,
    }
}
</script>

<style scoped>
.eula-container {
    margin: 20px;
}

.eula {
    margin: 0px auto;
    max-width: 600px;
}
</style>


// WEBPACK FOOTER //
// src/js/components/eula.vue